import { StyledContainer } from "./styles";
import { useState } from "react";
import { sendInvocationEvent } from "../../../Utils";
import SVG from "react-inlinesvg";

const Thumbs = ({ invocationId, setFeedbackOpen, setFeedbackInvocation }) => {
  const [liked, setLiked] = useState(null);

  // if (!invocationId) return null;

  return (
    <StyledContainer className="like-container">
      {/* thumbs down */}
      {liked === -1 && (
        <a
          href="#"
          className="like"
          aria-label="Thumbs Down Selected"
          onClick={(e) => {
            e.preventDefault();
            setLiked(null);
            sendInvocationEvent(invocationId, "undislike");
          }}
        >
          <SVG
            className="thumb"
            src="/assets/thumbsdown-filled.svg"
            aria-hidden="true"
          />
        </a>
      )}

      {(liked === null || liked === 1) && (
        <a
          href="#"
          className="like"
          aria-label="Give this a Thumbs Down"
          onClick={(e) => {
            e.preventDefault();
            setLiked(-1);
            setFeedbackOpen("dislike");
            setFeedbackInvocation(invocationId);
            sendInvocationEvent(invocationId, "dislike");
          }}
        >
          <SVG
            className="thumb"
            src="/assets/thumbsdown.svg"
            aria-hidden="true"
          />
        </a>
      )}

      {/* thumbs up*/}
      {liked === 1 && (
        <a
          href="#"
          className="like on"
          aria-label="Thumbs Up Selected"
          onClick={(e) => {
            e.preventDefault();
            setLiked(null);
            sendInvocationEvent(invocationId, "unlike");
          }}
        >
          <SVG
            className="thumb"
            src="/assets/thumbsup-filled.svg"
            aria-hidden="true"
          />
        </a>
      )}

      {(liked === null || liked === -1) && (
        <a
          href="#"
          className="like"
          aria-label="Give this a Thumbs Up"
          onClick={(e) => {
            e.preventDefault();
            setLiked(1);
            setFeedbackOpen("like");
            setFeedbackInvocation(invocationId);
            sendInvocationEvent(invocationId, "like");
          }}
        >
          <SVG
            className="thumb"
            src="/assets/thumbsup.svg"
            aria-hidden="true"
          />
        </a>
      )}
      <p>Make Sudowrite smarter by rating this prose</p>
    </StyledContainer>
  );
};

export default Thumbs;
